module.exports = __webpack_public_path__ + "static/main_header-c997c2e9518e9246dfd7043b1ae38a8b.png";